import * as React from "react";

import { CssBaseline } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { ApplicationRouter } from "src/router";
import { authStore } from '../auth';
import { observer } from 'mobx-react';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#fafafa",
    },
  },
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiListItem: {
      button: {
        "&:focus": {
          backgroundColor: "#00000000",
        },
      },
    },
  },
});

export class Application extends React.Component {
  public render() {    
    const queryParams = new URLSearchParams(window.location.search);

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <ApplicationRouter />
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/application/Application.tsx